<template>
    <!-- Form 1 Template -->
    <v-container>
        <UserInfo :company="company" :forms="forms"  ref="userinfo"></UserInfo>
        <component v-for="(page, index) in pages" :ref="reference(index)" :section="index + 1" :key="page['id']" :is="page"  :forms="forms"></component>
         <v-flex xs12 class="form1table" >
            <table>
                <tr>
                    <th>RESIDUAL RISK RATING</th>
                    <th>ACTION REQUIRED</th> 
                   
                </tr>
                <tr>
                    <td><strong>HIGH (H) (>81%)
                    Possibility of serious injury occurring
                    </strong>
                    </td>
                    <td>The activity must not take
                    place at all.
                    You must identify further
                    controls to reduce the risk
                    rating.
                    </td>
                </tr>
                <tr>
                    <td><strong>MEDIUM (M) (41%-80%)
                        Possibility of significant injury
                        or over 3 day absence occurring
                        </strong>
                    </td>
                    <td>If it is not possible to lower risk
                    further, you will need to
                    consider the risk against the
                    benefit. Monitor risk
                    assessments at this rating
                    more regularly and closely.
                    </td>
                </tr>
                <tr>
                    <td><strong>LOW (L) (0-40%)
                    Possibility of minor injury only
                    </strong>
                    </td>
                    <td>No further action required.</td>
                </tr>
            </table>
            </v-flex>
    </v-container>
</template>
<script>

import UserInfo from './UserInfo';
import Lighting from './Lighting';
import Activities from './Activities';
import Surface from './Surface';
import Keyboard from './Keyboard';
import Weight from './Weight'
import Monitor from './Monitor';
import Chair from './Chair';
import Breaks from './Breaks';
import Form2 from './Form2';
import Stage from '@/components/Stage';
import db from '@/components/firebase.init';
export default {
    data(){

        return{
            company: {},
            forms:{},
            numberOfPage:0,
            total_score: 0,
            total_na: 0,
            pages:['Surface', 'Keyboard', 'Lighting', 'Weight', 'Monitor', 'Chair', 'Breaks', 'Form2', 'Activities'],
            currentPage: "",
            window:{
                width: 0,
                height: 0
            },
            id: '',
            isSubmit: false,
            error_msg: [],
            company_id: this.$route.params.companyId,
            forms_id: this.$route.params.formsId,
            showButton: false,
            showMenu: true,
        }
    },
    methods:{
        percentage(){
            return parseInt((33-this.total_score-this.total_na) / (33 - this.total_na) * 100)
        },
        getTotalScore(){
            for(var x = 0; x <= this.numberOfPage; x++ ){
                let score = this.$refs['page' + x][0].getTotalScore();
                let na = this.$refs['page' + x][0].getTotalNa();
                this.total_score += score
                this.total_na += na
            }
        },
        getCompany(){
            db.collection('company').doc(this.company_id).get()
            .then(doc =>{
                this.company = doc.data();
                Object.assign(this.company, {id: this.company_id});
            })
        },
        getForms(){
            db.collection('forms').doc(this.forms_id).get()
            .then(doc =>{
                this.forms = doc.data();
                Object.assign(this.forms, {forms_id: this.forms_id});
            })
        }, 
        found(event){
            return event.type == 'enter';
        },
        handleResize(){
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            if(this.window.width <= 1224){
                this.showButton = true;
                this.showMenu = false;
            }
        },
        reference(index){
            this.numberOfPage = index;
            return 'page' + index;
        },
        savePercentage(id){
            let percentage = this.percentage()
            console.log(percentage);
            db.collection('forms').doc(id).update(
                {
                    percentage: percentage
                }
            )
        },
        //submit all form using their own submit methods
  
        //validate forms
        validate(){
            this.error_msg = [];
            let valid = this.$refs.userinfo.validate();
            //if user info have not been filled or invalid
            if(!valid){
                this.error_msg.push('Personal Info')
            }
            //validate the rest of the forms
            for(var x = 0; x <= this.numberOfPage; x++){
                if(this.$refs['page' + x][0].invalid()){
                    this.error_msg.push(x+1);
                }
            }
            //if no errors, proceed to submit
            if(!this.error_msg.length){
                this.submit();
            }
        }
    },
    components:{
   Lighting,
        UserInfo,
        Activities,
        Surface,
        Keyboard,
        Weight,
        Monitor,
        Chair,
        Breaks,
    Form2,
        'stage' : Stage
    },
    beforeMount(){
        this.getCompany();
        this.getForms();
    },
    created(){
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('touchstart',(ev)=>{
            if(ev.id == this.id){
                console.log("test") 
                this.currentPage = e.id;
                console.log(this.currentPage);
            }
        });
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

<style scoped>
table {
  width:100%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 15px;
  text-align: left;
}
table tr:nth-child(2) {
  background-color: red;
}
table tr:nth-child(3) {
 background-color: yellow;
}
table tr:nth-child(4) {
 background-color: rgb(49, 255, 49);
}
table th {
  background-color: rgb(131, 131, 131);
  color: rgb(0, 0, 0);
}


</style>